(ns arthur.subs.playback
  "Layer-2 extractors over the transport. Cheap by construction: each one reads a
  path and returns a value, so a tick that changes only `:frame` notifies only
  the things that asked for `:frame`."
  (:require [arthur.domain.clip :as clip]
            [arthur.footage.store :as store]
            [re-frame.core :as rf]))

(rf/reg-sub ::frame    (fn [db _] (get-in db [:playback :frame])))
(rf/reg-sub ::playing? (fn [db _] (get-in db [:playback :playing?])))
(rf/reg-sub ::rate     (fn [db _] (get-in db [:playback :rate])))
(rf/reg-sub ::loop?    (fn [db _] (get-in db [:playback :loop?])))
(rf/reg-sub ::muted?   (fn [db _] (get-in db [:playback :muted?])))
(rf/reg-sub ::range    (fn [db _] (get-in db [:playback :range (get-in db [:ui :open])])))
(rf/reg-sub ::fps      (fn [db _] (get-in db [:clip :fps])))
;; The open symbol can have a local stage size; otherwise it follows the project.
(rf/reg-sub ::stage-size
 :<- [:arthur.subs.playback/clip-id]
 :<- [:arthur.subs.playback/revision]
 :<- [:arthur.subs.playback/open]
 (fn [[id _ sid] _]
   (when-let [document (:clip (store/entry id))]
     (clip/stage document sid))))
(rf/reg-sub ::clip-id (fn [db _] (:clip/current db)))
(rf/reg-sub ::revision (fn [db _] (:paint/revision db)))
(rf/reg-sub ::open (fn [db _] (get-in db [:ui :open])))
(rf/reg-sub ::width :<- [::stage-size] (fn [[w _] _] w))
(rf/reg-sub ::height :<- [::stage-size] (fn [[_ h] _] h))
(rf/reg-sub ::audio    (fn [db _] (get-in db [:clip :audio])))
(rf/reg-sub ::footage  (fn [db _] (:footage db)))
;; The document's identity on the server. Not derived and not large — an id, a
;; name, the project version and the last thing a save or an open said.
(rf/reg-sub ::project  (fn [db _] (:project db)))
